import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { INavbarData, fadeInOut} from '../sidenav/helper';

@Component({
  selector: 'app-sublevel-menu',
  templateUrl: './sublevel-menu.component.html',
  styleUrls: ['./sublevel-menu.component.css'],
  animations: [
    fadeInOut,
    trigger('submenu', [
      state(
        'hidden',
        style({
          height: '0',
          overflow: 'hidden'
        })
      ),
      state(
        'visible',
        style({
          height: '*'
        })
      ),
      transition('visible <=> hidden', [
        style({ overflow: 'hidden' }),
        animate('{{ transitionParams }}')
      ]),
      transition('void => *', animate(0))
    ])
  ]
})
export class SublevelMenuComponent {
  @Input() data: INavbarData = {
    routerLink: '',
    icon: '',
    isVisible: false,
    label: '',
    items: [],
  };
  // @Input() data: any;
  // @Output() labelClicked:EventEmitter<INavbarData>=new EventEmitter<INavbarData>;
  @Input() collapsed = false;
  @Input() animating: boolean | undefined;
  @Input() expanded: boolean | undefined;
  @Input() multiple: boolean = false;
  

  constructor(
    public router: Router,
    private dynamicTabsService: DynamicTabsService,private actRoute: ActivatedRoute
  ) { }
  tabs: any;
  screen: string = '';
  paramId: number = 0;
  item: any;
  ngOnInit(): void {

  }
 
  createTabsFromNavbarData(item: any): void {
    if (item.label == 'Home'){
      this.actRoute.queryParams.subscribe(params => {
        this.screen = params["screen"];
        this.paramId = +params["MasterPolicyId"]
        let id = params["UserId"];
        //  sessionStorage.setItem('userId',id);
  
        if (this.screen == "MasterPolicyDetail") {
          if (this.paramId > 0) {
            this.item = { id: this.paramId, label: "Policy Details", routerLink: "Policy Details", type: "policy" };
            this.dynamicTabsService.createTabsFromNavbarData(this.item);
            // this.dynamicTabService.createTabsFromNavbarData(this.item);
          }
        }
        else if (this.screen == "AssociationAdd") {
          this.item = { id: -7, routerLink: 'AssnAddNew', label: 'Add New' };
          this.dynamicTabsService.createTabsFromNavbarData(this.item);
        }
        else if (this.screen == "AbandonedGoApps") {
          this.item = { id: -11, routerLink: 'guides/abandoned', label: 'Abandoned Apps' };
          this.dynamicTabsService.createTabsFromNavbarData(this.item);
        }
      });
    }
      
    else
    this.dynamicTabsService.createTabsFromNavbarData(item);
  }
  handleClick(item: INavbarData): void {
    if (!this.multiple) {
      if (this.data.items && this.data.items.length > 0) {
        for (let modelIem of this.data.items) {
          if (item !== modelIem && modelIem.expanded) {
            modelIem.expanded = false;
          }
        }
      }
    }
    // this.createTabsFromNavbarData();
    item.expanded = !item.expanded;

  }

  getActiveClass(item: INavbarData): string {
    return item.expanded && this.router.url.includes(item.routerLink) ? 'active-sublevel' : '';
  }
}
